import { useState, useEffect } from 'react';
import PasswordMask from 'lib/react-password-mask';
import { useNavigate } from 'react-router-dom';

import styles from './LoginView.module.scss';

import userIcon from 'assets/images/user-circle.svg';
import lockIcon from 'assets/images/lock.svg';
import eyeCloseIcon from 'assets/images/eye-closed.svg';
import eyeOpenIcon from 'assets/images/eye-opened.svg';
import crossIcon from 'assets/images/red-cross.svg';

import CompanyAndTitle from 'components/topbar/_CompanyAndTitle';
import LinearGradientDivider from 'components/linear-gradient-divider/LinearGradientDivider';

import { validateUser } from 'slices/AppSlice';
import { selectAuthenticateStatus } from 'selectors/selectors';

import { useDispatch, useSelector } from 'react-redux';

const LoginView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isAuth = useSelector(selectAuthenticateStatus);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [hasError, setHasError] = useState(false);

    const onLoginClick = () => {
        const payload = {
            username,
            password
        };
        dispatch(validateUser(payload));
    };

    const onErrorCloseClick = () => {
        setHasError(false);
    };

    useEffect(() => {
        if (isAuth === true) {
            setHasError(false);
            navigate('/');
        } else if (isAuth === false) {
            setHasError(true);
            navigate('/login');
        }
    }, [isAuth]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <CompanyAndTitle />
                <div className={styles.headerSection}></div>
                <LinearGradientDivider
                    topColor={'#222222'}
                    bottomColor={'#FFFFFF'}
                />
            </div>

            <div className={styles.loginPanel}>
                <div className={styles.panelHeader}>Login</div>
                <div className={styles.panelContent}>
                    {hasError && (
                        <div className={styles.error}>
                            <div>Incorrect username or password</div>
                            <img src={crossIcon} onClick={onErrorCloseClick} />
                        </div>
                    )}
                    <div className={styles.field}>
                        <img src={userIcon} className={styles.fieldIcon} />
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className={`${styles.textbox} ${
                                hasError ? styles.hasError : ''
                            }`}
                        />
                    </div>
                    <div
                        className={styles.field}
                        style={{ marginBottom: '70px' }}
                    >
                        <img src={lockIcon} className={styles.fieldIcon} />
                        <PasswordMask
                            id="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            className={`${styles.textbox} ${
                                hasError ? styles.hasError : ''
                            }`}
                            onChange={(e) => setPassword(e.target.value)}
                            showButtonContent={
                                <img src={eyeCloseIcon} alt="" />
                            }
                            hideButtonContent={<img src={eyeOpenIcon} alt="" />}
                            buttonStyles={{
                                backgroundColor: '#fff',
                                top: '55%'
                            }}
                        />
                    </div>
                    <div>
                        <button
                            disabled={hasError}
                            className={styles.loginBtn}
                            onClick={onLoginClick}
                        >
                            Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginView;
